export default __webpack_public_path__ + "static/que_esperas-75c006186595cad399a6dd8388e2ca67.png";